var map = {
	"./devicebox.png": "8b79",
	"./deviceboxSle.png": "7c74",
	"./farm_location_active.png": "6e11",
	"./insert.png": "9297",
	"./location.png": "2bf9",
	"./soil.png": "39e3",
	"./weaterStation.png": "ff4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9997";